




















































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

import CKEditor from "@/components/ckeditor.vue";

@Component({
  components: { ckeditor: CKEditor },
})
export default class extends Mixins(MyForm) {
  @Prop() categories!: any;

  @Prop() apps!: any;

  changeContent(e: any) {
    console.log(e);
  }

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.$confirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            this.confirmLoading = true;
            const res = await this.$store.dispatch("help/edit", {
              id: this.editId,
              ...values,
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success("操作成功");
              this.handleCancel();
            } else {
              this.$message.error("操作失败");
            }
            this.confirmLoading = false;
          },
        });
      }
    });
  }

  async mounted() {
    this.spinLoading = true;
    const res = await this.$store.dispatch("help/detail", {
      id: this.editId,
    });
    if (res && res.Data) {
      this.formData = res.Data;
    }
    this.spinLoading = false;
  }
}
